<template>
  <div style="width: 100%; height: 72px">
    <div
      ref="bgc"
      @mouseleave="handleMouseleave"
      style="display: flex; justify-content: center; width: 100%; height: 72px"
      :class="path == '/' ? 'bagc' : 'noBgc'"
    >
      <div :class="path == '/' ? 'w' : 'now'">
        <div style="margin-right: 34px" class="logoImg"></div>

        <div :class="path == '/' ? 'navBox active' : 'navBox'" @click="navGet('1')">
          网站首页
          <div class="bor"></div>
        </div>
        <div :class="path == '/lsitFs' ? 'navBox active' : 'navBox'" @click="navGet('2')">
          继续教育
          <div class="bor"></div>
        </div>
        <!-- <div :class="path == '/zyjy' ? 'navBox active' : 'navBox'" @click="navGet('9')">
          职业教育
          <div class="bor"></div>
        </div>
        <div :class="path == '/resourcesList' ? 'navBox active' : 'navBox'" @click="navGet('10')">
          课程资源库
          <div class="bor"></div>
        </div> -->
        <div :class="path == '/car' ? 'navBox active' : 'navBox'" @click="navGet(3)">
          购物车
          <div class="bor"></div>
        </div>
        <div :class="path == '/studyMain' ? 'navBox active' : 'navBox'" @click="navGet(7)">
          学习中心
          <div class="bor"></div>
        </div>
        <div :class="path == '/wzgn' ? 'navBox active' : 'navBox'" @click="navGet(4)">
          帮助中心
          <div class="bor"></div>
        </div>
        <div :class="path == '/tzgg' ? 'navBox active' : 'navBox'" @click="navGet(5)">
          新闻资讯
          <div class="bor"></div>
        </div>
        <div :class="path == '/zscy' ? 'navBox active' : 'navBox'" @click="navGet(6)">
          证书查验
          <div class="bor"></div>
        </div>
        <div :class="path == '/invoice' ? 'navBox active' : 'navBox'" @click="navGet(14)">
          开具发票
          <div class="bor"></div>
        </div>
        <!-- <div :class="path == '/jiti' ? 'navBox active' : 'navBox'" @click="navGet(11)">
          集体报名
          <div class="bor"></div>
        </div> -->
         <!-- <div :class="path == '/zscy' ? 'navBox active' : 'navBox'" @click="navGet(12)">
          商务合作
          <div class="bor"></div>
        </div> -->
        <div class="loginBox" v-if="this.$store.state.m_user.realName == '' || this.$store.state.m_user.realName == null">
          <span @click="regist">注册</span>/ <span @click="login">登录</span>
        </div>
        <div class="nologinBox" v-else>
          <div class="nameBox" @click="goStudy">{{ this.$store.state.m_user.realName }}</div>
          <span style="margin: 0 10px; padding-bottom: 2px" class="su">|</span>
          <span @click="loginOut" class="noLogis">退出</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { logout } from '@/api/login.js';
import { mapMutations } from 'vuex';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: ['value'],
  props: ['isTeam'],

  metaInfo: {
    title: '安徽职业与成人教育学习网-专业技术人员在线报名学习平台 '
  },

  data() {
    // 这里存放数据
    return {
      iconSHow: false,
      indexShow: 1,
      logo: '',
      url: '',
      list: [],
      path: '',
      className: '',
      userName: '', //用户名称
      localValue: '0702',
      fp: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {
    // localValue: {
    //   get() {
    //     return this.value; // 返回父组件传递的值
    //   }
    // }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    ...mapMutations('m_user', ['REAL_NAME']),
    handleMouseleave() {
      this.$refs.bgc.style.background = 'none !important';
      this.$refs.bgc.style.transition = 'all 0.2s linear';
    },
    //点击姓名跳到学习中心
    goStudy() {
      if (this.isTeam) {
        this.$confirm('离开该页面则无法继续拼团, 是否继续?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push({
              path: '/studyMain'
            });
          })
          .catch(() => {});
      } else {
        this.$router.push({
          path: '/studyMain'
        });
      }
    },
    //更多
    moke() {
      this.$router.push({
        path: '/lsitFs'
      });
    },
    //目录点击
    goList(msg, item) {
      console.log(msg, item);
      this.$router.push({
        path: '/lsitFs',
        query: {
          codeNo: msg.codeNo, //第二级
          fCodeNo: item.codeNo //第一级
        }
      });
    },
    //退出登录
    loginOut() {
       if (this.isTeam) {
        this.$confirm('离开该页面则无法继续拼团, 是否继续?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
             this.$confirm('是否要退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.REAL_NAME('');
          localStorage.removeItem('token');
          localStorage.removeItem('bmShow');
          this.userName = '';
          logout({}).then(res => {
            this.$message({
              message: '退出登录成功！',
              type: 'success'
            });
            this.$router.push('/');
          });
        })
        .catch(() => {});
          })
          .catch(() => {});
      } else {
          this.$confirm('是否要退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.REAL_NAME('');
          localStorage.removeItem('token');
          localStorage.removeItem('bmShow');
          this.userName = '';
          logout({}).then(res => {
            this.$message({
              message: '退出登录成功！',
              type: 'success'
            });
            this.$router.push('/');
          });
        })
        .catch(() => {});
      }
  
    },
    searClass(id) {
      if (this.className == '' && id !== 1) {
        return false;
      }
      this.localValue = {
        localValue: '',
        className: this.className
      };
      console.log(this.$route.path);
      this.$emit('updateParentValue', this.localValue); // 当输入框的值发生变化时，通过$emit事件告知父组件更新值
      if (this.$route.path !== '/lsitFs') {
        this.$router
          .push({
            path: '/lsitFs',
            query: {
              className: this.className
            }
          })
          .catch(err => {
            console.log('重复路由');
          });
      }
    },
    changeKe() {
      this.iconSHow = !this.iconSHow;
      console.log(this.iconSHow);
    },
    login() {
      this.$router.push('/login');
    },
    regist() {
      this.$router.push('/regist');
    },
    navGet(id) {
      if (this.isTeam) {
        this.$confirm('离开该页面则无法继续拼团, 是否继续?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.indexShow = id;
            if (id == 1) {
              this.$router.push('/').catch(err => {
                console.log('重复路由');
              });
            } else if (id == 2) {
              //默认选中专业课
              this.$router.push({ path: '/lsitFs', query: { fCodeNo: '0702' } }).catch(err => {
                console.log('重复路由');
              });
            } else if (id == 9) {
              this.$router.push('/zyjy').catch(err => {
                console.log('重复路由');
              });
            } else if (id == 3) {
              this.$router.push('/car').catch(err => {
                console.log('重复路由');
              });
            } else if (id == 4) {
              this.$router.push('/wzgn').catch(err => {
                console.log('重复路由');
              });
            } else if (id == 5) {
              this.$router.push('/tzgg').catch(err => {
                console.log('重复路由');
              });
            } else if (id == 6) {
              this.$router.push('/zscy').catch(err => {
                console.log('重复路由');
              });
            } else if (id == 7) {
              this.$router.push('/studyMain').catch(err => {
                console.log('重复路由');
              });
            }else if (id == 11) {
              this.$router.push('/jiti').catch(err => {
                console.log('重复路由');
              });
            }else if (id == 14) {
              console.log(11);
              
              this.$router.push('/invoice').catch(err => {
                console.log('重复路由');
              });
            }
             else if (id == 8) {
              this.$router
                .push({
                  path: '/studyMain1',
                  query: {
                    id: '8'
                  }
                })
                .catch(err => {
                  console.log('重复路由');
                });
            } else if (id == '10') {
              this.$router.push('/resourcesList').catch(err => {
                console.log('重复路由');
              });
            }
          })
          .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });
          });
      } else {
        this.indexShow = id;
        if (id == 1) {
          this.$router.push('/').catch(err => {
            console.log('重复路由');
          });
        } else if (id == 2) {
          //默认选中专业课
          this.$router.push({ path: '/lsitFs', query: { fCodeNo: '0702' } }).catch(err => {
            console.log('重复路由');
          });
        } else if (id == 9) {
          this.$router.push('/zyjy').catch(err => {
            console.log('重复路由');
          });
        } else if (id == 3) {
          this.$router.push('/car').catch(err => {
            console.log('重复路由');
          });
        } else if (id == 4) {
          this.$router.push('/wzgn').catch(err => {
            console.log('重复路由');
          });
        } else if (id == 5) {
          this.$router.push('/tzgg').catch(err => {
            console.log('重复路由');
          });
        } else if (id == 6) {
          this.$router.push('/zscy').catch(err => {
            console.log('重复路由');
          });
        } else if (id == 7) {
          this.$router.push('/studyMain').catch(err => {
            console.log('重复路由');
          });
        }else if (id == 11) {
          this.$router.push('/jiti').catch(err => {
            console.log('重复路由');
          });
        }
         else if (id == 8) {
          this.$router
            .push({
              path: '/studyMain1',
              query: {
                id: '8'
              }
            })
            .catch(err => {
              console.log('重复路由');
            });
        } else if (id == '10') {
          this.$router.push('/resourcesList').catch(err => {
            console.log('重复路由');
          });
        }
        else if (id == 14) {
              console.log(11);
              
              this.$router.push('/invoice').catch(err => {
                console.log('重复路由');
              });
            }
      }
    },
    destroyed() {
      localStorage.removeItem('userName1');
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(this.isTeam, '55555');

    if (this.$route.query.className) {
      this.className = this.$route.query.className;
    }
    this.path = this.$route.path;
    console.log(this.path);
    if (this.path == '/') {
      this.iconSHow = true;
    } else {
      this.iconSHow = false;
    }
    this.userName = localStorage.getItem('userName1');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.url = this.$store.state.m_user.url;
      this.list = this.$store.state.m_user.list;
    }, 300);
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */

.nologinBox {
  margin-left: 20px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  display: flex;
  .nameBox{
    max-width:60px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.now {
  position: relative;
  width: 1400px;
  height: 72px;
  display: flex;
  align-items: center;
  .logoImg {
    width: 312px;
    height: 42px;
    background: url('../../assets/img/logo.png') no-repeat 100% 100%;
 background-size: contain;
  }
  .navBox {
    width: 90px;
    text-align: center;
    height: 71px;
    line-height: 71px;
    margin-right: 4px;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
    position: relative;
  }
  .loginBox {
    margin-left: 20px;
    width: 109px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #ffffff;
    line-height: 36px;
    font-size: 18px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}
.w {
  position: fixed;
  top: 0;
  z-index: 9;
  width: 1400px;
  height: 72px;
  display: flex;
  align-items: center;
  .logoImg {
    width: 312px;
    height: 42px;
    background: url('../../assets/img/logo.png') no-repeat 100% 100%;
    background-size: contain;
  }
  .navBox {
    width: 120px;
    text-align: center;
    height: 71px;
    line-height: 71px;
    margin-right: 4px;
    font-size: 18px;
    color: #fff;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 135px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    margin-left: 20px;
    width: 109px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    // border: 1px solid #ffffff;
    line-height: 36px;
    font-size: 18px;
    text-align: center;
    color: #fff;
    cursor: pointer;
  }
}
.noBgc {
  background: #fff !important;
  cursor: pointer;
  transition: background-color 1s ease; /* 定义多个过渡 */
  .logoImg {
    width: 312px !important;
    height: 42px !important;
    background: url('../../assets/img/logo.png') no-repeat 100% 100% !important;
    background-size: contain !important;
  }
  .navBox {
    width: 120px;
    font-size: 18px;
    color: #222222 !important;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 135px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    // border: 1px solid #dadada !important;
    color: #999999 !important;
    cursor: pointer;
  }
  .nologinBox {
    // margin-left: 90px;
    height: 36px;
    line-height: 36px;
    font-size: 18px;
    text-align: center;
    color: #4076f6 !important;
    cursor: pointer;
    display: flex;
    align-items: center;
    .nameBox{
    max-width:60px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  }
  .noLogis {
    color: #666;
  }
  .su {
    color: #666;
  }
  .navBox:hover {
    color: #4076f6 !important;
    cursor: pointer;
    .bor {
      opacity: 1 !important;
    }
  }
  .active {
    color: #4076f6 !important;
    .bor {
      opacity: 1 !important;
    }
  }
  .loginBox:hover {
    // background: linear-gradient(103deg, #6996ff 0%, #4076f6 100%) !important;
    color: #4076f6 !important;
    // border: 0 !important;
  }
}
.bagc:hover {
  background: #fff;
  cursor: pointer;
  transition: background-color 1s ease; /* 定义多个过渡 */
  .logoImg {
    width: 312px !important;
    height: 42px !important;
    background: url('../../assets/img/logo.png') no-repeat 100% 100% !important;
    background-size:contain !important;
  }
  .navBox {
    width: 120px;
    font-size: 18px;
    color: #222222 !important;
    cursor: pointer;
    position: relative;
    .bor {
      opacity: 0;
      position: absolute;
      bottom: 0;
      width: 135px;
      height: 3px;
      background: linear-gradient(90deg, #6996ff 0%, #4076f6 100%);
      border-radius: 4px 4px 0px 0px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .loginBox {
    // border: 1px solid #dadada !important;
    color: #999999 !important;
    cursor: pointer;
  }
  .nologinBox {
    display: flex;
    // margin-left: 90px;
    height: 36px;
    line-height: 36px;
    font-size: 18px;
    text-align: center;
    color: #4076f6 !important;
    cursor: pointer;
  }
  .navBox:hover {
    color: #4076f6 !important;
    cursor: pointer;
    .bor {
      opacity: 1 !important;
    }
  }
  .active {
    color: #4076f6 !important;
    cursor: pointer;
  }
  .loginBox:hover {
    // background: linear-gradient(103deg, #6996ff 0%, #4076f6 100%) !important;
    color: #4076f6 !important;
    // border: 0 !important;
  }
}
</style>
